import { MaybeRefOrGetter, Ref, toValue } from "vue";
import type { TokenInputActions } from "@/src/design_system/form_elements/token_input/composables/useTokenInputActions";
import { DS_TOKEN_INPUT_CLASSES } from "@/src/design_system/form_elements/token_input/constants/classes";
import { caretIndexFromPoint } from "@/src/design_system/form_elements/token_input/utils/caretIndexFromPoint";

interface UseTokenInputGapClickOptions {
  wrapper: Readonly<Ref<HTMLElement | null>>;
  isInactive: MaybeRefOrGetter<boolean>;
  deselect: () => void;
  moveCaret: TokenInputActions["moveCaret"];
}

interface UseTokenInputGapClick {
  onFieldClick: (event: MouseEvent) => void;
}

export const useTokenInputGapClick = ({
  wrapper,
  isInactive,
  deselect,
  moveCaret,
}: UseTokenInputGapClickOptions): UseTokenInputGapClick => {
  const isGapClick = (field: HTMLElement, event: MouseEvent): boolean =>
    event.target === field || event.target === field.parentElement;

  const onFieldClick = (event: MouseEvent): void => {
    const field = wrapper.value;

    if (toValue(isInactive) || !field || !isGapClick(field, event)) {
      return;
    }

    // DOM order equals token order; template refs inside v-for are not ordered.
    const chips = field.querySelectorAll(`:scope > .${DS_TOKEN_INPUT_CLASSES.Chip}`);
    const rects = Array.from(chips, chip => chip.getBoundingClientRect());

    deselect();
    void moveCaret(caretIndexFromPoint(rects, { x: event.clientX, y: event.clientY }));
  };

  return { onFieldClick };
};
